<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Bordro</label>
            <v-file-uploader v-model="value" :accept="['png','jpeg','jpg','xlsx']" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    }
}
</script>